import {useContext, useEffect, useState, useCallback, useRef} from 'react';
import {Button, MenuItem, CircularProgress, Container, FormControlLabel, Grid, TextField, FormControl, Select} from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {NotificationContext} from "../../../../components/NotificationContext";
import Prompt from "../../../../customUtil/Prompt";
import {InvoiceTrackerService, InvoiceOutBoundService, BillingCategory, InvoiceSendService} from '../../../../services';
import {CurrentUserContext} from "../../../../components/CurrentUserContext";
import { DataGrid, GridToolbar, GridEditInputCell, GridRowEditStopReasons,
   useGridApiRef, GridRowModes, GridActionsCellItem } from "@mui/x-data-grid";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';

const InvoiceTrackerForm = () => {
    const methods = useForm();
    const {handleSubmit, control} = methods;
    const user = useContext(CurrentUserContext);
    const [data, setData] = useState({});
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [billingCategory, setBillingCategory] = useState([]);
    const {showMessage, showError} = useContext(NotificationContext);
    const [isReady, setIsReady] = useState(false);
    const {id} = useParams();
    const [status, setStatus] = useState('')
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const [editedRow, setEditedRow] = useState([]);
    const [enableEdit, setEnableEdit] = useState(false);
    const apiRef = useGridApiRef();
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
    const [isVisibleDialog, setVisibleDialog] = useState(false);
    let promiseTimeout;
    const invoiceStatus = ['Draft', 'Created', 'Deferred', 'Paid', 'Invalid'];
    const [rowModesModel, setRowModesModel] = useState({});
    const [enableSend, setEnableSend] = useState(false);
 

    const preProcessEditCellProps = async (params) => {
        const errorMessage = await validateProjectCode(params.props.value);
        return { ...params.props, error: errorMessage };
      };

      const StyledBox = styled('div')(({ theme }) => ({
    //    height: 400,
        width: '100%',
        '& .MuiDataGrid-cell--editable': {
          backgroundColor: theme.palette.mode === 'dark' ? '#D6F3FF' : '#EAF9FF',
          '& .MuiInputBase-root': {
            height: '100%',
          },
        },
        '& .Mui-error': {
          backgroundColor: `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
          color: theme.palette.mode === 'dark' ? '#ff4343' : '#750f0f',
        },
      }));

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );

      const columns = [
        {field: 'invoiceNumber', headerName: 'Inovice Number', width: 120},
        {field: 'projectCode', headerName: 'Project Code', width: 150, preProcessEditCellProps, renderEditCell: renderEditProject, editable: true},
        {field: 'costPointVendorId', headerName: 'Vendor Id', width: 100, editable: true},
        {field: 'billingCategory', headerName: 'Billing Category', width: 400, editable: true,
        type: 'singleSelect', 
        valueOptions: () => { const options = [];
            billingCategory?.map((type) =>options.push(type.billingCategory))
            return options
          }
        },
        {field: 'itemName', headerName: 'Item Name', width: 150},        
        {field: 'invoiceLineAmount', headerName: 'Line Amount', width: 120},    
        {field: 'invoiceLineQty', headerName: 'Line Quantity', width: 100},         
        {
          field: 'actions',
          type: 'actions',
          headerName: 'Actions',
          width: 100,
          cellClassName: 'actions',
          getActions: ({ id }) => {
            const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
            if (isInEditMode) {
              return [
                <GridActionsCellItem
                  icon={<SaveIcon />}
                  label="Save"
                  sx={{
                    color: 'primary.main',
                  }}
                  onClick={handleSaveClick(id)}
                />,
                <GridActionsCellItem
                  icon={<CancelIcon />}
                  label="Cancel"
                  className="textPrimary"
                  onClick={handleCancelClick(id)}
                  color="inherit"
                />,
              ];
            }
            if(enableEdit){
            return [
              <GridActionsCellItem
                icon={<EditIcon />}
                label="Edit"
                className="textPrimary"
                onClick={handleEditClick(id)}
                color="inherit"
               
              />
            ];
           } else{
            return [
              <GridActionsCellItem
                icon={<BlockIcon />}
                label="Edit"
                className="textPrimary"
                onClick={handleEditClick(id)}
                color="inherit"
                disabled
              />
            ];
           }                        
          },
        },
    ]
  
      useEffect(() => {       
        const unblock = history.block((location) => {
          if (location.pathname !== `integrations/onecp/invoiceTracker/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

      const handleRowEditStop = (params, event) => {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(params.id);
        setList(list?.map((row) => (row.id === updatedRow.id ? updatedRow : row)));
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
          event.defaultMuiPrevented = true;
        }
      };

      const handleRowEditStart = (
        params,
        event,
      ) => {
        event.defaultMuiPrevented = true;
      };

      const handleSend = () => {
        setLoading(true);
        InvoiceSendService.sendInvoiceToCp(data.invoiceNumber).then((response) => {
          if(response.data.success === false){
            showError(response.data.msg + ". You will receive a notification shortly");
            setLoading(false)
          }else{
            showMessage(response.data.msg)
            setLoading(false)
            window.location.reload(); 
          }
        })
      }

      const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
      };
    
      const handleSaveClick = (id) => () => {
       const newRow = apiRef.current.getRowWithUpdatedValues(id);
       setList(list?.map((row) => (row.id === newRow.id ? newRow : row)));
       let tempList = [];
       if(editedRow.length === 0){
        setEditedRow([...editedRow, newRow])
      }else{
        for(let row of editedRow){
          if(row.id !== newRow.id){
             tempList.push(row);
          }
        }
        tempList.push(newRow);
        setEditedRow(tempList);
      } 
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View, ignoreModifications: false } });
      };
    
    
      const handleCancelClick = (id) => () => {
        setRowModesModel({
          ...rowModesModel,
          [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });
    
         };

      // const processRowUpdate = (newRow) => {
      //   console.log(newRow)
      //   let tempList = [];
      //   const updatedRow = { ...newRow};
      //   setList(list.map((row) => (row.id === newRow.id ? updatedRow : row)));
      //   if(editedRow.length === 0){
      //     setEditedRow([...editedRow, updatedRow])
      //   }else{
      //     for(let row of editedRow){
      //       if(row.id !== updatedRow.id){
      //          tempList.push(row);
      //       }
      //     }
      //     tempList.push(updatedRow);
      //     setEditedRow(tempList);
      //   }  
      //   return updatedRow;
      // };
    
      const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
      };

      function renderEditProject(params) {
        return <NameEditInputCell {...params} />;
      }

      const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
      ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.error.main,
          color: theme.palette.error.contrastText,
        },
      }));

      function NameEditInputCell(props) {
        const { error } = props;      
        return (
          <StyledTooltip open={!!error} title={error}>
            <GridEditInputCell {...props} />
          </StyledTooltip>
        );
      }   
      
      function validateProjectCode(projectCode) {      
        return new Promise((resolve) => {
            promiseTimeout = setTimeout(
            () => {
              var pattern = new RegExp('^[0-9]{5}\.[0-9]{4}\.[0-9]{4}$')
              const matches = !pattern.test(projectCode);
              resolve(matches ? `projectCode must be in the following format xxxxx.xxxx.xxxx` : null);
            },
            Math.random() * 300 + 100,
          );
        });
      }

      useEffect(() => {
        return () => {
          clearTimeout(promiseTimeout);
        };
      }, []);

      useEffect(() => {     
        InvoiceTrackerService.getById(id)
        .then((response) => {
            setData(response.data)
            if(response.data != {}){
              getInvoiceLineDetail(response.data);
            }
           setIsReady(true); 
           if(response?.data.status === "Draft"){
            setEnableEdit(true);
            setEnableSend(true);
           }else{
            setEnableEdit(false);
           }
        });           
        BillingCategory.getAll().then((response) => {
            setBillingCategory(response.data);
            })         
        }, []);

          const getInvoiceLineDetail = (data) => {
            InvoiceOutBoundService.getInvoiceLine(data?.invoiceNumber)
            .then((response) => {
                setList(response?.data);             
                setLoading(false);
            }) 
          }

           

      const onSubmit = d => {
       setIsReady(false);
        setBlock(false);
        setVisibleDialog(false);
         d['lastUpdatedBy'] = user.currentUser.username;
        InvoiceTrackerService.update({...data, ...d}).then((response) => {
                showMessage('Invoice Updated');       
                setIsReady(true);
            }).catch((err) => {
                showError(err.message);
            });        
        if(editedRow.length > 0){
          setIsReady(true);   
          setLoading(true) 
            InvoiceOutBoundService.updateInvoiceLine(editedRow[0].invoiceNumber, editedRow).then((response) => {   
                 setLoading(false); 
                 })
        }
        // else{
        //   setTimeout(() => {
        //     setIsReady(true);
        //  //   history.push("/integrations/onecp/invoiceTracker");    
        //   }, 1500);  
        // };       
    
         
    };


    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     

    
     
          const handleChange = (e) => {
        setStatus(e.target.value);
      }
   
      const onSave = (event) => {
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }
            

              return (
                <Container>
                    <header>
                        <h1>Invoice Tracker Form</h1>
                    </header>
        
                    <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
                    <Prompt
                       visible={isVisibleDialog}
                       onClose={() => setVisibleDialog(false)}
                       onOk={() => {
                       setTriggerExit({...triggerExit, onOk: true});
                       setVisibleDialog(false);
                       setBlock(false);
                    }}
                       onSave={onSave}
                    />
                        <Grid container>
                        <Grid item xs={5} m={2}>
                        <Controller
                            name="invoiceNumber"
                            control={control}
                            fullWidth
                            as={<TextField/>}
                            label="Invoice Number"
                            disabled
                            color="primary"
                            variant="outlined"
                            defaultValue={data.invoiceNumber}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="projectId"
                            control={control}
                            fullWidth
                            label="Project Id"
                            as={<TextField/>}
                            color="primary"
                            disabled
                            variant="outlined"
                            defaultValue={data.projectId}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="oneNetInvoiceNo"
                            control={control}
                            fullWidth
                            label="OneNet Invoice Number"
                            as={<TextField/>}
                            color="primary"
                            disabled
                            variant="outlined"
                            defaultValue={data.oneNetInvoiceNo}
                        />
                    </Grid>               

                    <Grid item xs={5} m={2}>

                       <Controller
                           name="asnNumber"
                           control={control}
                           label="ASN Number"
                           fullWidth
                           color="primary"
                           as={<TextField/>}
                           disabled
                           variant="outlined"
                           defaultValue={data.asnNumber}
                       />
                       </Grid>
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="orderNumber"
                            control={control}
                            fullWidth
                            as={<TextField/>}
                            label="Purchase Order"
                            disabled
                            color="primary"
                            variant="outlined"
                            defaultValue={data.orderNumber}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="invoiceDate"
                            control={control}
                            fullWidth
                            label="Invoice Date"
                            as={<TextField/>}
                            color="primary"
                            disabled
                            variant="outlined"
                            defaultValue={data.invoiceDate}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="lastUpdatedBy"
                            control={control}
                            fullWidth
                            as={<TextField/>}
                            label="Last Updated By"
                            disabled
                            color="primary"
                            variant="outlined"
                            defaultValue={data.lastUpdatedBy ? data.lastUpdatedBy : ''}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                        <Controller
                            name="lastUpdated"
                            control={control}
                            fullWidth
                            label="Last Updated"
                            as={<TextField/>}
                            color="primary"
                            disabled
                            variant="outlined"
                            defaultValue={data.lastUpdated ? data.lastUpdated : ''}
                        />
                    </Grid>
                    <Grid item xs={5} m={2}>
                    <FormControlLabel label="Invoice Status"
                                              htmlFor="invoiceStatus"
                                              labelPlacement="top"
                                              control={<></>}/>
                       <Controller
                           name="status"
                           control={control}
                           label="Invoice Status"
                           fullWidth
                           color="primary"
                           as={<Select value={status} onChange={(e) => handleChange(e)}
                                               >
                                 {invoiceStatus?.map((el) => (
                        <MenuItem    value={el}>
                        {el}
                      </MenuItem>
                                 ))}      
                              
                             </Select>}
                           variant="outlined"
                           defaultValue={data.status}
                       />
                       </Grid>   

                       <Grid item xs={5} m={2}>
                       <FormControlLabel label="Voucher"
                                              htmlFor="partnerSiteId"
                                              labelPlacement="top"
                                              control={<></>}/>
                         <Controller
                             name="cpVoucherNumber"
                             control={control}
                             fullWidth
                             color="primary"
                             as={<TextField/>}                             
                             variant="outlined"
                             defaultValue={data.cpVoucherNumber}
                         />
                         </Grid>                        
                        </Grid>
                        <button hidden={true} ref={refSubmitButtom} type={"submit"} />
                   
                 

                    <Grid xs={12} m={2}>    
                    <header>
                        <h1>Invoice Lines</h1>
                    </header>
                    <StyledBox>   
                       <DataGrid   
                           apiRef={apiRef}
                           autoHeight
                           rows={list}
                           columns={columns}
                           slots={{toolbar: GridToolbar}}
                           loading={loading}
                           editMode="row"
                           rowModesModel={rowModesModel}
                           onRowModesModelChange={handleRowModesModelChange}
                           onRowEditStart={handleRowEditStart}
                           onRowEditStop={handleRowEditStop}
                           //onRowClick={handleEvent}
                          //  processRowUpdate={processRowUpdate}                           
                           disableColumnSelector                                    
                           disableVirtualization={false}      
                           rowHeight={35}      
                           pageSize={20}
                           rowsPerPageOptions={[5, 10, 20, 50, 100]}
                           pagination
                           slotProps={{
                            toolbar: 
                            { 
                              showQuickFilter: true ,
                             quickFilterProps: { debounceMs: 600 },
                                     }
                          }}
                       />
                       </StyledBox>  
                    </Grid>
                    <Grid container spacing={6}>
                     <Grid item xs={11} >
                     <Button variant="contained" color="primary" type="submit">Update</Button>
                       </Grid>  
                       <Grid item xs={1} >
                     <Button variant="contained" color={enableSend? "primary" : "secondary"}  disabled={enableSend ? false : true} onClick={handleSend}>Send</Button>
                       </Grid> 
                     </Grid>  
                    </form>
                </Container>
              );

}

export default InvoiceTrackerForm;